export const blockIconsEditorInsertChartOutlined = (
	<span className='material-symbols-outlined'>insert_chart_outlined</span>
);
